import React, { useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { toast } from "sonner";

export function BulkAssignDialog({ regii, freePersons, today, onClose, onDone }) {
  const [regieId, setRegieId] = useState("");
  const [count, setCount] = useState(Math.min(freePersons.length, 3));
  const [submitting, setSubmitting] = useState(false);

  const regie = regii.find((r) => r.id === regieId);

  const submit = async () => {
    if (!regieId) return toast.error("Selectează o regie");
    const n = Math.max(0, Math.min(parseInt(count) || 0, freePersons.length));
    if (n === 0) return toast.error("Nicio persoană selectată");
    setSubmitting(true);
    try {
      const ids = freePersons.slice(0, n).map((p) => p.id);
      await api.post("/schedule", {
        label: regie.name,
        start_date: today,
        end_date: today,
        color: regie.color || "#F59E0B",
        person_ids: ids,
        car_ids: [],
        is_regie: true,
        regie_id: regieId,
      });
      toast.success(`${n} ${n === 1 ? "persoană atribuită" : "persoane atribuite"} pe ${regie.name}`);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare");
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="bulk-assign-dialog">
        <DialogHeader><DialogTitle>✨ Atribuire rapidă pe regie</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="bg-emerald-50 border border-emerald-200 rounded p-3 text-sm">
            <div className="font-semibold text-emerald-700">🟢 {freePersons.length} persoane libere azi ({today})</div>
            <div className="text-xs text-emerald-600 mt-1">{freePersons.slice(0, 6).map((p) => `${p.nume} ${p.prenume}`).join(", ")}{freePersons.length > 6 ? ` +${freePersons.length - 6} altele` : ""}</div>
          </div>
          <div>
            <Label className="small-label">Regie *</Label>
            <Select value={regieId} onValueChange={setRegieId}>
              <SelectTrigger className="mt-1" data-testid="bulk-regie-select"><SelectValue placeholder="Alege regia"/></SelectTrigger>
              <SelectContent>
                {regii.map((r) => (
                  <SelectItem key={r.id} value={r.id}>
                    <span className="inline-flex items-center gap-2">
                      <span className="w-2 h-2 rounded-full" style={{ background: r.color || "#F59E0B" }}/>
                      {r.name}{r.firma ? ` · ${r.firma}` : ""}
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="small-label">Câte persoane să atribui?</Label>
            <Input
              type="number"
              min={1}
              max={freePersons.length}
              value={count}
              onChange={(e) => setCount(e.target.value)}
              className="mt-1"
              data-testid="bulk-count"
            />
            <div className="text-[11px] text-zinc-500 mt-1">Sistem va atribui primele {Math.min(parseInt(count) || 0, freePersons.length)} persoane libere (alfabetic).</div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anulează</Button>
          <Button onClick={submit} disabled={submitting || !regieId} className="bg-amber-500 hover:bg-amber-600" data-testid="bulk-assign-submit">
            {submitting ? "Se atribuie…" : "Atribuie"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
